import _defineProperty from "/Users/ismaelgoncalves/Documents/Projetos/front_nuts/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: ['nav-link usuario-cadastro-tab', {
      active: _vm.tabIndex === 0
    }],
    attrs: {
      "data-tab": "0",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.tabIndex = 0;
      }
    }
  }, [_vm._v(" Cadastro ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: ['nav-link usuario-dashboard-tab', {
      active: _vm.tabIndex === 1
    }],
    attrs: {
      "data-tab": "1",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.tabIndex = 1;
      }
    }
  }, [_vm._v(" Dashboard ")])])])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm.userLimitError ? _c('b-alert', {
    staticClass: "user-limit-alert",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('div', [_c('strong', [_vm._v("Limite de usuários atingido.")]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" Sua empresa já atingiu o limite de usuários disponíveis no plano. Para cadastrar mais usuários, contrate Usuários Extras no Marketplace. ")])]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToMarketplace
    }
  }, [_vm._v(" Ir para Marketplace ")])]) : _vm._e(), _c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', {
    staticClass: "usuario-form-layout"
  }, [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "usuario-fields"
  }, [_c('b-form-group', {
    attrs: {
      "id": "nome",
      "label-for": "nome",
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('nome'),
      "autofocus": ""
    },
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "usuario",
      "label-for": "usuario",
      "label": "E-mail"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "state": _vm.validateState('usuario')
    },
    model: {
      value: _vm.$v.form.usuario.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.usuario, "$model", $$v);
      },
      expression: "$v.form.usuario.$model"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Vendedor",
      "label-for": "vendedor"
    }
  }, [_c('VueSelect', {
    ref: "buscaVendedor",
    attrs: {
      "filterable": false,
      "options": _vm.vendedores
    },
    on: {
      "input": _vm.setVendedor,
      "open": _vm.onSearchVendedor,
      "search": _vm.onSearchVendedor
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.vendedor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vendedor", $$v);
      },
      expression: "form.vendedor"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do vendedor ")])], 2)], 1), _vm.isCreate ? _c('b-form-group', {
    attrs: {
      "id": "password",
      "label-for": "password",
      "label": "Senha"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "maxlength": "72",
      "state": _vm.validateState('password')
    },
    model: {
      value: _vm.$v.form.password.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.password, "$model", $$v);
      },
      expression: "$v.form.password.$model"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" A senha deve ter entre 4 e 72 caracteres. ")])], 1) : _vm._e(), _vm.isCreate ? _c('b-form-group', {
    attrs: {
      "id": "password_confirmation",
      "label-for": "password_confirmation",
      "label": "Confirmar senha"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "maxlength": "72",
      "state": _vm.validateState('password_confirmation')
    },
    model: {
      value: _vm.$v.form.password_confirmation.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.password_confirmation, "$model", $$v);
      },
      expression: "$v.form.password_confirmation.$model"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" A confirmação deve ser igual à senha. ")])], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "id": "status",
      "label-for": "status",
      "label": "Ativo"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.status == 'A'
    },
    on: {
      "change": _vm.setAtivo
    }
  }), _c('span')])])]), _vm.hasFeature(_vm.FEATURES.MOD_FOOD) ? _c('b-form-group', {
    attrs: {
      "id": "entregador-habilitado",
      "label-for": "entregador-habilitado-switch",
      "label": "Entregas"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "switch switch-icon mr-3"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.entregador_habilitado,
      expression: "form.entregador_habilitado"
    }],
    attrs: {
      "id": "entregador-habilitado-switch",
      "type": "checkbox",
      "disabled": _vm.form.status !== 'A'
    },
    domProps: {
      "checked": Array.isArray(_vm.form.entregador_habilitado) ? _vm._i(_vm.form.entregador_habilitado, null) > -1 : _vm.form.entregador_habilitado
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.entregador_habilitado,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "entregador_habilitado", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "entregador_habilitado", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "entregador_habilitado", $$c);
        }
      }
    }
  }), _c('span')])]), _c('div', [_c('strong', [_vm._v("Pode atuar como entregador")]), _c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Libera a aba de Entregas no aplicativo e permite habilitar este usuário no Cardápio Digital. ")])])]), _vm.form.status !== 'A' ? _c('b-form-text', {
    attrs: {
      "text-variant": "warning"
    }
  }, [_vm._v(" Ative o usuário antes de habilitá-lo como entregador. ")]) : _vm._e()], 1) : _vm._e()], 1)]), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Atribuir perfil de recurso",
      "label-for": "perfil-recurso"
    }
  }, [_c('b-input-group', [_c('b-form-select', {
    attrs: {
      "id": "perfil-recurso",
      "options": _vm.profileOptions
    },
    on: {
      "change": _vm.onProfileChange
    },
    model: {
      value: _vm.selectedProfileId,
      callback: function callback($$v) {
        _vm.selectedProfileId = $$v;
      },
      expression: "selectedProfileId"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    staticClass: "font-weight-bold",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.openProfileModal
    }
  }, [_vm._v(" Adicionar ")])], 1)], 1)], 1), _c('div', {
    staticClass: "form-user-access"
  }, [_c('label', {
    staticClass: "mb-5 mt-0"
  }, [_vm._v(" Selecione os recursos que o usuário poderá acessar ")]), _vm._l(_vm.recursos, function (r, index) {
    return _c('div', {
      key: 'recurso' + index,
      staticClass: "w-100"
    }, [_c('b-row', {
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "md": "auto"
      }
    }, [_c('h3', [_c('b-button', {
      on: {
        "click": function click($event) {
          _vm.collapseToggle(_vm.resourceCollapseId('usuario', r, index));
        }
      }
    }, [_vm._v("+")])], 1)]), _c('b-col', [_c('h3', [_vm._v(_vm._s(r.name))])]), _c('b-col', {
      attrs: {
        "md": "auto"
      }
    }, [_c('span', {
      staticClass: "switch switch-icon"
    }, [_c('label', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.right",
        value: 'Negar/Permitir',
        expression: "'Negar/Permitir'",
        modifiers: {
          "hover": true,
          "right": true
        }
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: r.checked,
        expression: "r.checked"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.isProfileSelected
      },
      domProps: _defineProperty({
        "value": true,
        "checked": r.checked
      }, "checked", Array.isArray(r.checked) ? _vm._i(r.checked, true) > -1 : r.checked),
      on: {
        "change": [function ($event) {
          var $$a = r.checked,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = true,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(r, "checked", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(r, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(r, "checked", $$c);
          }
        }, function ($event) {
          return _vm.checkMenu(r, _vm.isProfileSelected);
        }]
      }
    }), _c('span')])])])], 1), _c('b-collapse', {
      staticClass: "mb-5",
      attrs: {
        "id": _vm.resourceCollapseId('usuario', r, index)
      }
    }, _vm._l(r.submenus, function (sub, key) {
      return _c('div', {
        key: 'sub' + key,
        staticClass: "text-center ml-20 w-100",
        attrs: {
          "align-v": "center"
        }
      }, [_c('div', {
        staticClass: "recursos-list"
      }, [_c('span', [_vm._v(_vm._s(sub.name))]), _c('span', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.right",
          value: 'Negar/Permitir',
          expression: "'Negar/Permitir'",
          modifiers: {
            "hover": true,
            "right": true
          }
        }],
        staticClass: "switch switch-icon"
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.recursos[index].submenus[key].checked,
          expression: "\n                                  recursos[index].submenus[key].checked\n                                "
        }],
        attrs: {
          "type": "checkbox",
          "disabled": _vm.isProfileSelected
        },
        domProps: _defineProperty({
          "value": true,
          "checked": _vm.recursos[index].submenus[key].checked
        }, "checked", Array.isArray(_vm.recursos[index].submenus[key].checked) ? _vm._i(_vm.recursos[index].submenus[key].checked, true) > -1 : _vm.recursos[index].submenus[key].checked),
        on: {
          "change": [function ($event) {
            var $$a = _vm.recursos[index].submenus[key].checked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = true,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && _vm.$set(_vm.recursos[index].submenus[key], "checked", $$a.concat([$$v]));
              } else {
                $$i > -1 && _vm.$set(_vm.recursos[index].submenus[key], "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.$set(_vm.recursos[index].submenus[key], "checked", $$c);
            }
          }, function ($event) {
            return _vm.syncMenuFromSubmenus(r);
          }]
        }
      }), _c('span')])])])]);
    }), 0)], 1);
  })], 2)], 1)], 1)], 1), _c('b-tab', [_c('b-row', {
    staticClass: "usuario-form-layout"
  }, [_c('b-col', {
    attrs: {
      "lg": "5",
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "dashboard-config-intro"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-4"
  }, [_c('div', [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v("Dashboard do usuário")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" Os cards respeitam os recursos marcados em Cadastro. ")])]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.dashboard_habilitado,
      expression: "form.dashboard_habilitado"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isDashboardAlwaysEnabled
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.form.dashboard_habilitado) ? _vm._i(_vm.form.dashboard_habilitado, true) > -1 : _vm.form.dashboard_habilitado
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.form.dashboard_habilitado,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "dashboard_habilitado", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "dashboard_habilitado", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "dashboard_habilitado", $$c);
        }
      }, _vm.normalizeDashboardCards]
    }
  }), _c('span')])])]), _c('p', {
    staticClass: "dashboard-config-copy mb-0"
  }, [_vm._v(" Habilitar dashboard para este usuário ")])])]), _c('b-col', {
    attrs: {
      "lg": "7",
      "md": "7"
    }
  }, [_vm.dashboardEnabledForForm && _vm.hasEligibleDashboardCards ? _c('div', {
    staticClass: "dashboard-card-flags"
  }, _vm._l(_vm.dashboardCardGroups, function (group) {
    return _c('div', {
      key: 'dashboard-card-group-' + group.name,
      staticClass: "dashboard-card-group"
    }, [_c('h5', [_vm._v(_vm._s(group.name))]), _vm._l(group.cards, function (card) {
      return _c('div', {
        key: 'dashboard-card-' + card.id,
        staticClass: "dashboard-card-option"
      }, [_c('div', [_c('strong', [_vm._v(_vm._s(card.title))]), _c('span', {
        staticClass: "dashboard-card-option-description"
      }, [_vm._v(" " + _vm._s(card.description) + " ")])]), _c('span', {
        staticClass: "switch switch-icon"
      }, [_c('label', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.left",
          value: 'Exibir/Ocultar',
          expression: "'Exibir/Ocultar'",
          modifiers: {
            "hover": true,
            "left": true
          }
        }]
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.isDashboardCardSelected(card.id)
        },
        on: {
          "change": function change($event) {
            return _vm.toggleDashboardCard(card.id);
          }
        }
      }), _c('span')])])]);
    })], 2);
  }), 0) : _vm.dashboardEnabledForForm ? _c('div', {
    staticClass: "dashboard-empty-state"
  }, [_vm._v(" Nenhum card disponível com os recursos atuais. ")]) : _vm._e()])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_usuario_novo",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'usuariosLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1), _c('b-modal', {
    attrs: {
      "size": "xl",
      "title": "Perfis de recurso",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetProfileForm
    },
    model: {
      value: _vm.profileModalVisible,
      callback: function callback($$v) {
        _vm.profileModalVisible = $$v;
      },
      expression: "profileModalVisible"
    }
  }, [_c('b-tabs', {
    model: {
      value: _vm.profileTabIndex,
      callback: function callback($$v) {
        _vm.profileTabIndex = $$v;
      },
      expression: "profileTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.profileFormTitle
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveProfileResource.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "perfil-recurso-nome",
      "label-for": "perfil-recurso-nome",
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "perfil-recurso-nome",
      "maxlength": "100"
    },
    model: {
      value: _vm.profileForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.profileForm, "nome", $$v);
      },
      expression: "profileForm.nome"
    }
  })], 1), _c('div', {
    staticClass: "form-user-access perfil-recurso-access"
  }, [_c('label', {
    staticClass: "mb-5 mt-0"
  }, [_vm._v(" Selecione os recursos que este perfil poderá acessar ")]), _vm._l(_vm.profileForm.recursos, function (r, index) {
    return _c('div', {
      key: 'perfil-recurso' + index,
      staticClass: "w-100"
    }, [_c('b-row', {
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "md": "auto"
      }
    }, [_c('h3', [_c('b-button', {
      on: {
        "click": function click($event) {
          _vm.collapseToggle(_vm.resourceCollapseId('perfil', r, index));
        }
      }
    }, [_vm._v("+")])], 1)]), _c('b-col', [_c('h3', [_vm._v(_vm._s(r.name))])]), _c('b-col', {
      attrs: {
        "md": "auto"
      }
    }, [_c('span', {
      staticClass: "switch switch-icon"
    }, [_c('label', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.right",
        value: 'Negar/Permitir',
        expression: "'Negar/Permitir'",
        modifiers: {
          "hover": true,
          "right": true
        }
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: r.checked,
        expression: "r.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: _defineProperty({
        "value": true,
        "checked": r.checked
      }, "checked", Array.isArray(r.checked) ? _vm._i(r.checked, true) > -1 : r.checked),
      on: {
        "change": [function ($event) {
          var $$a = r.checked,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = true,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(r, "checked", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(r, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(r, "checked", $$c);
          }
        }, function ($event) {
          return _vm.checkMenu(r);
        }]
      }
    }), _c('span')])])])], 1), _c('b-collapse', {
      staticClass: "mb-5",
      attrs: {
        "id": _vm.resourceCollapseId('perfil', r, index)
      }
    }, _vm._l(r.submenus, function (sub, key) {
      return _c('div', {
        key: 'perfil-sub' + key,
        staticClass: "text-center ml-20 w-100",
        attrs: {
          "align-v": "center"
        }
      }, [_c('div', {
        staticClass: "recursos-list"
      }, [_c('span', [_vm._v(_vm._s(sub.name))]), _c('span', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.right",
          value: 'Negar/Permitir',
          expression: "'Negar/Permitir'",
          modifiers: {
            "hover": true,
            "right": true
          }
        }],
        staticClass: "switch switch-icon"
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.profileForm.recursos[index].submenus[key].checked,
          expression: "\n                            profileForm.recursos[index].submenus[key].checked\n                          "
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: _defineProperty({
          "value": true,
          "checked": _vm.profileForm.recursos[index].submenus[key].checked
        }, "checked", Array.isArray(_vm.profileForm.recursos[index].submenus[key].checked) ? _vm._i(_vm.profileForm.recursos[index].submenus[key].checked, true) > -1 : _vm.profileForm.recursos[index].submenus[key].checked),
        on: {
          "change": [function ($event) {
            var $$a = _vm.profileForm.recursos[index].submenus[key].checked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = true,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && _vm.$set(_vm.profileForm.recursos[index].submenus[key], "checked", $$a.concat([$$v]));
              } else {
                $$i > -1 && _vm.$set(_vm.profileForm.recursos[index].submenus[key], "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.$set(_vm.profileForm.recursos[index].submenus[key], "checked", $$c);
            }
          }, function ($event) {
            return _vm.syncMenuFromSubmenus(r);
          }]
        }
      }), _c('span')])])])]);
    }), 0)], 1);
  })], 2), _c('div', {
    staticClass: "text-center mt-6"
  }, [_c('b-button', {
    staticClass: "font-weight-bold",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.profileSaving
    }
  }, [_vm._v(" Salvar perfil ")]), _vm.profileForm.id_usuario_perfil_recurso ? _c('b-button', {
    staticClass: "font-weight-bold",
    attrs: {
      "variant": "clean"
    },
    on: {
      "click": _vm.resetProfileForm
    }
  }, [_vm._v(" Cancelar edição ")]) : _vm._e()], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Gerenciar"
    }
  }, [_vm.resourceProfiles.length === 0 ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Nenhum perfil cadastrado. ")]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ações")])])]), _c('tbody', _vm._l(_vm.resourceProfiles, function (profile) {
    return _c('tr', {
      key: 'profile-row' + profile.id_usuario_perfil_recurso
    }, [_c('td', {
      staticClass: "font-weight-bolder"
    }, [_vm._v(_vm._s(profile.nome))]), _c('td', {
      staticClass: "text-right"
    }, [_c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip",
        value: 'Editar',
        expression: "'Editar'"
      }],
      staticClass: "btn-icon mr-2",
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function click($event) {
          return _vm.editProfileResource(profile);
        }
      }
    }, [_c('Pencil', {
      attrs: {
        "size": 16,
        "title": "Editar"
      }
    })], 1), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip",
        value: 'Excluir',
        expression: "'Excluir'"
      }],
      staticClass: "btn-icon",
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteProfileResource(profile);
        }
      }
    }, [_c('TrashCanIcon', {
      attrs: {
        "size": 16
      }
    })], 1)], 1)]);
  }), 0)])])])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };